<template>
    <div>
			<block v-model="loading"></block>
        <v-card flat class="pa-4 bar">
            <div class="d-flex justify-end align-center">
				<v-btn 
					small 
					class="btn-save"
					@click="manageprint"
				>
					<v-icon>
						mdi-printer
					</v-icon>
				</v-btn>
				<v-btn 
					small 
					class="btn-save ml-2"
					@click="exportPdf"
				>
					<v-icon>
						mdi-file-pdf-box
					</v-icon>
				</v-btn>
				<v-btn 
					small 
					class="btn-save ml-2"
					@click="getJournal()"
				>
					<v-icon>
						mdi-magnify
					</v-icon>
				</v-btn>
            </div>
        </v-card>

        <v-row class="mx-1 mt-5">
            <v-col cols="12" md="6">
                <v-select
                    v-model="search.month"
                    :items="monthList"
                    item-text="text"
                    item-value="value"
                    label="Mes"
                    outlined
                    attach
                    dense
                ></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                    v-model="search.year"
                    label="Año"
                    outlined
                    type="number"
                    attach
                    dense
                    clearable
                ></v-text-field>
            </v-col>
        </v-row>

        <DxDataGrid 
			:dataSource="DataTable"
			:showBorders="true"
			:scrolling="{ useNative: true }"    
			:column-auto-width="true"
			:paging="{ enabled: false }"  
			style="max-height: 600px"
			@exporting="onExporting"
        >
			<DxExport :enabled="true"/>

			<DxColumn width="12%" dataField="accounting_entry_date" caption="Fecha" />
			<DxColumn width="12%" dataField="account_code" caption="Cuenta" />
            <DxColumn width="30%" dataField="accounting_entry_name" caption="Nombre" />
			<DxColumn width="30%" dataField="concept" caption="Concepto" />
            <!--DxColumn width="30%" dataField="debe" caption="SalAnterior" /-->
            <DxColumn width="14%" dataField="Debe" caption="Cargos" />
            <DxColumn width="14%" dataField="Haber" caption="Abono" />

			<DxColumn :group-index="0" data-field="ID_Accounting_item" caption="No. Partida" :sortOrder="'desc'" />
        </DxDataGrid>
        <alerts
			v-if="alert.show"
			v-on:close_alert="closeAlert"
			v-on:accept_alert="acceptAlert"
			:properties="alert"
		></alerts>
		<PrintDailyBook v-model="print"></PrintDailyBook>
    </div>
</template>

<script>
import {DxDataGrid, DxColumn, DxExport} from 'devextreme-vue/data-grid';
import PrintDailyBook from '../../../components/ReportsAndPrintings/PrintDailyBook.vue';
import alerts from '@/components/Alerts.vue';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
export default {
	name: "DialyBook",
	components: {
		DxDataGrid,
		DxColumn,
		alerts,
		PrintDailyBook, 
		DxExport
	},
	props: ['win'],
	data() {
		return {
			loading: false,
			DataTable: [],
			panel: 0,
			tab: null,
			key: 0,
			search:{
				month: null,
				year: null,
			},
			alert: {
				type: "success",
				show: false,
				header: "",
				body: "",
			},
			monthList: [
				{text: 'Enero', value: 1},
				{text: 'Febrero', value: 2},
				{text: 'Marzo', value: 3},
				{text: 'Abril', value: 4},
				{text: 'Mayo', value: 5},
				{text: 'Junio', value: 6},
				{text: 'Julio', value: 7},
				{text: 'Agosto', value: 8},
				{text: 'Septiembre', value: 9},
				{text: 'Octubre', value: 10},
				{text: 'Noviembre', value: 11},
				{text: 'Diciembre', value: 12},
			],
			Currency: JSON.parse(localStorage.getItem('branch')).Currency,
			print: {
				show: false,
				data: [],
			},
			searchbusiness: {},
			infobusiness: {},
		}
	},
	computed:{
		columnWidth() {
			return this.$vuetify.breakpoint.smAndDown ? '150px' : 'auto !important';
		},
	},
	mounted() {
		this.searchbusiness.branch = JSON.parse(localStorage.getItem("user")).branch || "";
		this.searchbusiness.business = JSON.parse(localStorage.getItem("user")).businessid || "";
		this.getInfoBusiness()
	},
	methods: {
		onExporting(e) {
			const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('LibroDiario');

			exportDataGrid({
                    component: e.component,
                    worksheet,
                    topLeftCell: { row: 4, column: 1 },
                }).then((cellRange) => {
                    // header
                    const headerRow = worksheet.getRow(2);
                    headerRow.height = 30;
                    worksheet.mergeCells(2, 1, 2, 8);

                    headerRow.getCell(1).value = `Libro Diario (${this.monthList.find(item => item.value === this.search.month)?.text} - ${this.search.year} )`;
                    headerRow.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
                    headerRow.getCell(1).alignment = { horizontal: 'center' };

                    // footer
                    const footerRowIndex = cellRange.to.row + 2;
                    const footerRow = worksheet.getRow(footerRowIndex);
                    worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

                    footerRow.getCell(1).value = '-';
                    footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true };
                    footerRow.getCell(1).alignment = { horizontal: 'right' };
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `LibroDiario${this.monthList.find(item => item.value === this.search.month)?.text}${this.search.year}.xlsx`);
                    });
                });
                e.cancel = true;
		},
		async getInfoBusiness() {
			let response = await this.$API.branches.findSpecificBranch(this.searchbusiness)
			this.infobusiness = response[0]
		},
		closeAlert() {
			this.alert.show = false;
		},
		acceptAlert() {
			this.alert.show = false;
		},
		showAlert(type, header, body, options = null) {
			type = type == null ? "danger" : type;
			this.alert.type = type;
			this.alert.header = header;
			this.alert.body = body;
			this.alert.show = true;
			this.alert.options = options != null ? options : null;
		},
		async getJournal(){
			try {
				this.loading = true

				if(this.search.month == null || this.search.year == null){
					this.showAlert("danger", "Error", "Debe seleccionar un mes y un año");
					return;
				}
				if(this.search.year.length != 4){
					this.showAlert("danger", "Error", "El año debe tener 4 digitos");
					return;
				}
				let response = await this.$API.accountingreports.getJournalData(this.search)
				
				this.DataTable = response.length ? response : []
			} catch (err) {
				console.error(err)
			} finally {
				this.loading = false
			}
		},
		async manageprint() {
			let branchinfo = JSON.parse(localStorage.getItem("branch")) 

			this.print = {
				show: true,
				data: {
					body: this.DataTable,
					branch: branchinfo,
					business: this.infobusiness,
					date: this.search
				},
			};
		},
		getReportDateText() {
			const month = Number(this.search.month);
			const year = Number(this.search.year);
			const lastDay = new Date(year, month, 0).getDate();
			const monthText = this.monthList.find(item => item.value === month)?.text || '';

			return `${lastDay} de ${monthText} de ${year}`;
		},
		getRecordID(record) {
			const date = this.$dateToISO
				? this.$dateToISO(record.accounting_entry_date)
				: record.accounting_entry_date;

			return `${record.ID_Accounting_item || ''}_${date}`;
		},
		parseMoneyValue(value) {
			return parseFloat(`${value || '0'}`.replace('$', '').replace(/,/g, '')) || 0;
		},
		formatMoneyValue(value) {
			const amount = this.parseMoneyValue(value);

			if (!amount) {
				return '';
			}

			return `$${amount.toLocaleString(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			})}`;
		},
		getDailyBookPdfRows(records) {
			const sortedRecords = [...records].sort((rec1, rec2) => {
				return this.getRecordID(rec1) > this.getRecordID(rec2) ? 1 : -1;
			});
			const rows = [];
			let currentID = null;
			let totals = { debe: 0, haber: 0 };

			const addTotalsRow = () => {
				rows.push([
					{ content: 'TOTAL PARTIDA', colSpan: 3, styles: { halign: 'right', fontStyle: 'bold' } },
					{ content: this.formatMoneyValue(totals.debe), styles: { halign: 'right', fontStyle: 'bold' } },
					{ content: this.formatMoneyValue(totals.haber), styles: { halign: 'right', fontStyle: 'bold' } },
				]);
			};

			sortedRecords.forEach((record) => {
				const recordID = this.getRecordID(record);

				if (recordID !== currentID) {
					if (currentID !== null) {
						addTotalsRow();
					}

					currentID = recordID;
					totals = { debe: 0, haber: 0 };
					rows.push([
						{ content: record.accounting_entry_date || '', styles: { fontStyle: 'bold' } },
						{ content: record.ID_Accounting_item || '', colSpan: 4, styles: { fontStyle: 'bold' } },
					]);
				}

				rows.push([
					record.account_code || '',
					record.accounting_entry_name || '',
					record.concept || '',
					this.formatMoneyValue(record?.Debe),
					this.formatMoneyValue(record?.Haber),
				]);

				totals.debe += this.parseMoneyValue(record?.Debe);
				totals.haber += this.parseMoneyValue(record?.Haber);
			});

			if (currentID !== null) {
				addTotalsRow();
			}

			return rows;
		},
		async exportPdf() {
			if (!this.DataTable.length) {
				this.showAlert("danger", "Error", "Debe consultar datos antes de generar el PDF");
				return;
			}

			this.loading = true;

			try {
				const doc = new jsPDF('p', 'pt', 'letter');
				const pageWidth = doc.internal.pageSize.getWidth();
				const pageHeight = doc.internal.pageSize.getHeight();
				const reportDate = this.getReportDateText();
				const businessName =
					this.infobusiness?.BusinessBillingName ||
					this.infobusiness?.BusinessName ||
					'';
				const rows = this.getDailyBookPdfRows(this.DataTable);
				const margin = { top: 78, right: 34, bottom: 34, left: 34 };
				const drawPageHeader = () => {
					doc.setFontSize(10);
					doc.setFont(undefined, 'bold');
					doc.text(businessName, pageWidth / 2, 38, { align: 'center'});
					doc.setFont(undefined, 'normal');
					doc.text(`Libro Diario al ${reportDate}`, pageWidth / 2, 51, { align: 'center' });
					if (this.Currency == '$') {
						doc.text('US DOLAR', pageWidth / 2, 64, { align: 'center' });
					}
				};

				autoTable(doc, {
					startY: margin.top,
					head: [['Cuenta', 'Nombre', 'Concepto', 'Cargo', 'Abono']],
					body: rows,
					theme: 'plain',
					margin,
					styles: {
						fontSize: 7,
						cellPadding: { top: 1.2, right: 1.5, bottom: 1.2, left: 1.5 },
						lineWidth: 0,
						overflow: 'linebreak',
						valign: 'top',
						textColor: 0,
					},
					headStyles: {
						fontSize: 7.5,
						fontStyle: 'bold',
						textColor: 0,
						lineWidth: { top: 0.6, bottom: 0.6 },
						lineColor: 0,
					},
					columnStyles: {
						0: { cellWidth: 65, halign: 'left' },
						1: { cellWidth: 105, halign: 'left' },
						2: { cellWidth: 244, halign: 'left' },
						3: { cellWidth: 60, halign: 'right' },
						4: { cellWidth: 60, halign: 'right' },
					},
					didDrawPage: () => {
						drawPageHeader();
					},
				});

				const accountantName = JSON.parse(localStorage.getItem("user"))?.AccountantName;
				const accountantAdditional = JSON.parse(localStorage.getItem("user"))?.AccountantAdditional;
				const auditorName = JSON.parse(localStorage.getItem("user"))?.AuditorName;
				const auditorAdditional = JSON.parse(localStorage.getItem("user"))?.AuditorAdditional;
				const signatureHeight = 60;
				let signatureY = doc.lastAutoTable.finalY + 42;

				if (signatureY + signatureHeight > pageHeight - margin.bottom) {
					doc.addPage();
					drawPageHeader();
					signatureY = 120;
				}

				doc.setFontSize(8);
				doc.text('__________________________________', pageWidth * 0.28, signatureY, { align: 'center' });
				doc.text(accountantName || 'Contador', pageWidth * 0.28, signatureY + 12, { align: 'center' });
				doc.text(accountantAdditional || '', pageWidth * 0.28, signatureY + 24, { align: 'center' });
				doc.text(accountantName ? 'Contador' : '', pageWidth * 0.28, signatureY + 36, { align: 'center' });

				doc.text('__________________________________', pageWidth * 0.72, signatureY, { align: 'center' });
				doc.text(auditorName || 'Auditor', pageWidth * 0.72, signatureY + 12, { align: 'center' });
				doc.text(auditorAdditional || '', pageWidth * 0.72, signatureY + 24, { align: 'center' });
				doc.text(auditorName ? 'Auditor' : '', pageWidth * 0.72, signatureY + 36, { align: 'center' });

				const pageCount = doc.internal.getNumberOfPages();
				for (let page = 1; page <= pageCount; page++) {
					doc.setPage(page);
					doc.setFontSize(7.5);
					doc.text(`Pág. ${page}/${pageCount}`, pageWidth - margin.right, 64, { align: 'right' });
				}

				window.open(doc.output('bloburl'));
			} catch (error) {
				this.showAlert('danger', 'Error', `No se pudo generar el PDF: ${error.message}`);
			} finally {
				this.loading = false;
			}
		},
	},
}
</script>

<style scoped>
.bar {
  max-width: 100%;
  background-color: rgb(60, 60, 60) !important;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-radius: 15px !important;
  margin: 16px 12px !important;
}
.btn-add{
  background-color: #3498DB  !important;
  color: white;
}
.btnsave{
  background-color: #00A178 !important;
  color: white;
}
.btnclean{
  background-color: #F29D35 !important;
  color: white;
}
.btndelete{
  background-color: #E3191E !important;
  color: white;
}
</style>
